import { SETTINGS_LANG_NAMES_MAP } from '../../constant'

export const getters = (gaApp) => ({
  // Приводим коды языков к понятным для i18n
  convertedLanguages() {
    return this.languages.map((lang) => {
      const nextLang = { ...lang, initialCode: lang.code }

      if (SETTINGS_LANG_NAMES_MAP[nextLang.code]) {
        nextLang.code = SETTINGS_LANG_NAMES_MAP[nextLang.code]
      }

      return nextLang
    })
  },

  // Приводим коды языков в сторах к понятным для i18n
  convertedStores() {
    const getConvertedLangCode = (code) => SETTINGS_LANG_NAMES_MAP[code] ?? code

    return this.stores.map((store) => {
      const languages =
        store.languages &&
        store.languages.map((lang) => {
          const nextLang = { ...lang, initialCode: lang.code }

          nextLang.code = getConvertedLangCode(nextLang.code)

          return nextLang
        })

      const languageDefaultCode =
        store.languageDefaultCode &&
        getConvertedLangCode(store.languageDefaultCode)

      return {
        ...store,
        ...(languages ? { languages } : {}),
        ...(languageDefaultCode ? { languageDefaultCode } : {}),
      }
    })
  },

  // Мапа языков i18n и тех, что пришли из api
  initialLanguagesCodeMap() {
    return this.convertedLanguages.reduce((acc, lang) => {
      // i18n код = коду из массива languages
      acc[lang.code] = lang.initialCode
      return acc
    }, {})
  },
})
